<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.activityId"
        placeholder="活动名称"
        style="width: 220px"
        class="filter-item"
        clearable
        filterable
      >
        <el-option
          v-for="item in activityList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>

      <!-- <el-select
        v-model="listQuery.status"
        placeholder="活动状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in ACTIVITY_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select> -->
      <!-- <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        style="margin-right:24px"
        startPlaceholder="开始时间"
        endPlaceholder="结束时间"
      /> -->
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table :data="scope.row.specs" size="small" border fit>
            <el-table-column align="center" prop="specsId" label="商品规格ID"></el-table-column>
            <el-table-column align="center" prop="specsName" label="规格名称"></el-table-column>
            <el-table-column align="center" prop="originalPrice" label="原价(元)"></el-table-column>
            <el-table-column
              align="center"
              prop="seckillPrice"
              label="秒杀价(元)"
            ></el-table-column>
            <el-table-column align="center" prop="seckillStock" label="秒杀库存"></el-table-column>
            <el-table-column align="center" prop="soldStock" label="已售库存"></el-table-column>
            <el-table-column align="center" prop="singleLimit" label="单次限购"></el-table-column>
            <el-table-column align="center" prop="totalLimit" label="用户总限购"></el-table-column>
            <el-table-column align="center" prop="status" label="状态">
              <template slot-scope="specScope">
                <div>{{ specScope.row.status === 1 ? "启用" : "停用" }}</div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column width="80" align="center" prop="goodsId" label="商品ID"></el-table-column>

      <el-table-column align="center" prop="goodsName" label="商品名称"> </el-table-column>
      <el-table-column label="商品主图" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 80px; height: 80px"
            :src="scope.row.mainGraph"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag style="color: #FFF;" :color="getValue(BRAND_STATUS_CSS, scope.row.status)">{{
            getValue(ACTIVITY_STATUS, scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="activityName" label="活动名称">
        <template slot-scope="scope">
          {{ scope.row.activityName || "-" }}
        </template>
      </el-table-column>

      <el-table-column align="center" prop="sort" label="排序"> </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 新增/编辑活动商品弹框 -->
    <ActivityGoodsForm
      :visible.sync="dialogFormVisible"
      :dialog-type="dialogType"
      :edit-data="editRow"
      :btn-loading="btnLoading"
      @confirm="saveActivityGoodsData"
    />
  </div>
</template>

<script>
import {
  getActivityGoods,
  editActivityGoods,
  deleteActivityGoods,
  getActivityList
} from "@/api/seckill";
import ActivityGoodsForm from "./activityGoodsForm.vue";
import { formatApiDate } from "@/utils/utils";
import { BRAND_STATUS_CSS } from "@/utils/enumUtileCss";
import { ACTIVITY_STATUS, getValue } from "@/utils/enumUtile";

export default {
  computed: {
    ACTIVITY_STATUS() {
      return ACTIVITY_STATUS;
    },
    formatApiDate() {
      return formatApiDate;
    },
    BRAND_STATUS_CSS() {
      return BRAND_STATUS_CSS;
    }
  },
  components: { ActivityGoodsForm },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        activityId: null
      },
      dialogFormVisible: false,
      dialogType: "",
      editRow: {},
      btnLoading: false,
      activityList: []
    };
  },
  created() {
    this.getList();
    this.onGetActivityList();
  },
  watch: {},
  methods: {
    getValue,
    /**
     * 查询活动列表
     */
    onGetActivityList() {
      getActivityList({ page: 1, pageSize: 1000 }).then(response => {
        this.activityList = response.data.entitys;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        pageSize: 20,
        activityId: null
      };
      this.getList();
    },

    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleDelete(row) {
      this.$confirm("确认删除该商品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteActivityGoods({ ids: String(row.id), activityId: row.activityId })
          .then(() => {
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000
            });
            this.getList();
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getActivityGoods(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 打开新增/编辑弹框
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      this.dialogType = type;
      if (type === "UPDATE" && editObj && editObj.activityId) {
        this.btnLoading = true;
        this.editRow = editObj;
        this.dialogFormVisible = status;
        this.btnLoading = false;
      } else {
        this.editRow = editObj;
        this.dialogFormVisible = status;
      }
    },
    /**
     * 保存活动商品数据
     * @param params
     */
    saveActivityGoodsData(params) {
      this.btnLoading = true;
      editActivityGoods(params)
        .then(res => {
          if (res.bizcode === 100) {
            this.getList();
            this.dialogFormVisible = false;
            this.$notify({
              title: "成功",
              message: "保存成功",
              type: "success",
              duration: 2000
            });
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    decreaseStock(row) {
      if (row.seckillStock > 0) {
        row.seckillStock--;
      }
    },
    increaseStock(row) {
      row.seckillStock++;
    },
    decreasePrice(row) {
      if (row.seckillPrice > 0) {
        row.seckillPrice = Math.max(0, row.seckillPrice - 0.01).toFixed(2);
      }
    },
    increasePrice(row) {
      row.seckillPrice = (parseFloat(row.seckillPrice) + 0.01).toFixed(2);
    }
  }
};
</script>
<style scoped lang="scss">
.specs-control {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
</style>
